import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  CustomContainer,
  connect,
  useRouter,
  Link
} from "../../atoms/DependencyHelper";
import LabelText from "../../atoms/label/LabelText";
import labels from "../../../config/labels";
import {
  checkIsOutOfStock,
  getHighlights,
  getPromotionVariant,
  showSpinner,
  hideSpinner,
  getDealExpiryTime,
  getProductImageUrl,
  getDisplayedRangeOnDealSelection,
  getCookieValue,
  componentCheckSize,
} from "../../../utils/helperServices";
import WhitePill from "../../atoms/whitePill/WhitePill";
import EmptyProductsContainer from "../emptyProductsContainer/EmptyProductsContainer";
import PageCounter from "../../atoms/pageCounter/PageCounter";
import DropDownComponent from "../../atoms/dropDown/DropDown";
import FilterNav from "../../molecules/filterNav/FilterNav";
import SortContainer from "../SortContainer/SortContainer";
import { displayHideFooter } from "../../../Redux/actions/footerAction";
import DealCard from "../../molecules/dealCard/DealCard";
import {
  getDealFilterByBrands,
  getDealFilterByPromotions,
  resetFilter,
  getDealFilterByPlanName,
  getDealFilterByPlanType,
  getDealFilterByContractDuration,
  getDealFilterByAccessories,
  getDealFilterByContractType,
} from "../../../services/filterDealService";
import GridBanner from "../../atoms/gridBanner/GridBanner";
import {
  link as AnalyticsLink,
  getUtagData as AnalyticsGetUtagData
} from "../../../services/analyticsUtag";
import config from "../../../config";
import UpgradeInfoBar from "../../atoms/upgradeInfoBar/upgradeInfoBar";
import {breadcrumbGenerator} from "../../../services/breadcrumbService";
import NativeSort from "../../molecules/nativeSort/NativeSort";
import types from "../../../config/types";
import styles from "./DealListContainer.module.scss";
import { MOBILE_WIDTH } from "../../../config/constants";

import {
  openBreakoutUrl
} from "../../../utils/miniAppUtil";

const DealListContainer = (props) => {
  const isMobile = componentCheckSize() < MOBILE_WIDTH;
	const isTablet = componentCheckSize() <= 768;
  const lblRecommendedForYou = props?.isDealGridPage ? labels.sortKeys.lbl_recommended : labels.lbl_recommend_for_you;
  const [page, setPage] = useState(props?.pageInfo?.current_page || 1);
  const [selected, setSelected] = useState(!props?.isDealSelection ? lblRecommendedForYou : props?.selectedSortVal);
  const [isUpgradePage, setIsUpgradePage] = useState(false);
  const [analyticsSent, setAnalyticsSent] = useState(false);
  const env = config.env;
  const urlPrefix = config.envConfigs[env].shoppingUrlPrefix;
  const imagePrefix = config.envConfigs[env].imagePrefix;

  useEffect(() => {
    props.displayHideFooter(props?.hide);
    if(router.pathname == "/shopping/upgrade") {
      setSelected(lblRecommendedForYou);
      setIsUpgradePage(true);
    }
  },[props?.hide]);

  useEffect(() => {
    setPage(props?.pageInfo?.current_page)
    setSelected(props?.selectedSortVal);
  },[props?.pageInfo]);

  const router = useRouter();

  function getSortParams() {
    let dropdownValues = [
      { label: lblRecommendedForYou },
      { label: labels.sortKeys.lbl_most_popular },
      { label: labels.sortKeys.lbl_low_to_high },
      { label: labels.sortKeys.lbl_high_to_low },
    ];
    return dropdownValues;
  }
  const dealSortValues = getSortParams();

  const handleSelected = (value) => {
    setSelected(value);
    props?.sortBy(value);
    props.analyticsHandleSortFilter(value);
  };

  const handleSelectedMobile = (flag, value = "") => {
    if (flag) {
      setSelected(value);
      props?.sortBy(value);
      props.analyticsHandleSortFilter(value);
    } else {
      setSelected(!props?.isDealSelection ? lblRecommendedForYou : "");
      props?.sortBy(!props?.isDealSelection ? lblRecommendedForYou : "");
    }
  };

  const PAGE_SIZE = props?.pageInfo?.page_size;
  const totalLength = props?.items?.length;
  const totalPages = props?.pageInfo?.total_pages;
  const lastItem =
    (props?.pageInfo?.current_page - 1) * props?.pageInfo?.page_size +
    totalLength;

    const scrollPagetoTop = () => {
      if (props.pageName=="upgrade"){
        if(isMobile) {
          window.scrollTo(0, 0);
        } else {
          window.scrollTo(0, 600);
        }
      }
    }

  const increasePageCount = () => {
    if (page < totalPages) {
      props?.updateCurrentPage(page + 1);
      setPage(page + 1);
      if(props?.isDealGridPage){
        window.scrollTo(0,0);
      }
      if(props?.isDealSelection) {
        props?.OnClickScrollViewElement();
      }
      scrollPagetoTop();
    }
  };


  const decreasePageCount = () => {
    if (page > 1) {
      props?.updateCurrentPage(page - 1);
      setPage(page - 1);
      if(props?.isDealGridPage){
        window.scrollTo(0,0);
      } else if(props?.isDealSelection) {
        props.OnClickScrollViewElement();
      }
      scrollPagetoTop();
    }
  };

  const handleCurrentPageChange = page => {
    props?.updateCurrentPage(page);
    setPage(page);
    scrollPagetoTop();
    if(props?.isDealGridPage){
      window.scrollTo(0,0);
    } else if(props?.isDealSelection) {
      props.OnClickScrollViewElement();
    }
  };

  const FilterText = getDisplayedRangeOnDealSelection(
    (props?.pageInfo?.current_page - 1) * PAGE_SIZE + 1,
    lastItem,
    props?.totalItemsCount,
    (props.pageName === "upgrade" || isMobile) ? "" : "results"
  );

  const removeBrandsHandler = brandObj => {
    let selectedBrands = props?.selectedBrands ? [...props?.selectedBrands] : [];
    brandObj.isChecked = false;
    const updatedArr = selectedBrands.filter(
      (brand) => brand.value != brandObj.value
    );
    getDealFilterByBrands(updatedArr);
  };

  const removePromotionsHandler = (promotionObj) => {
    let selectedPromotions = props?.selectedPromotions
      ? [...props?.selectedPromotions]
      : [];
    promotionObj.isChecked = false;
    const updatedArr = selectedPromotions.filter(
      (promotion) => promotion.value != promotionObj.value
    );
    getDealFilterByPromotions(updatedArr);
  };

  const removePlanTypeHandler = (plantypeObj) => {
    let selectedPlantype = props?.selectedPlantype
      ? [...props?.selectedPlantype]
      : [];
    plantypeObj.isChecked = false;
    const updatedArr = selectedPlantype.filter(
      (plantype) => plantype.value != plantypeObj.value
    );
    getDealFilterByPlanType(updatedArr);
  };

  const removePlanNameHandler = (plannameeObj) => {
    let selectedPlanname = props?.selectedPlanname
      ? [...props?.selectedPlanname]
      : [];
    plannameeObj.isChecked = false;
    const updatedArr = selectedPlanname.filter(
      (planname) => planname.value != plannameeObj.value
    );
    getDealFilterByPlanName(updatedArr);
  };

  const removeAccessoriesHandler = (accObj) => {
    let selectedAccName = props?.selectedAcccessories
      ? [...props?.selectedAcccessories]
      : [];
    accObj.isChecked = false;
    const updatedArr = selectedAccName.filter(
      (acc) => acc.value != accObj.value
    );
    getDealFilterByAccessories(updatedArr);
  };

  const removeContractDuration = (contractObj) => {
    let selectedContractDuration = props?.selectedContractDuration
      ? [...props?.selectedContractDuration]
      : [];
    contractObj.isChecked = false;
    const updatedArr = selectedContractDuration.filter(
      (ct) => ct.value != contractObj.value
    );
    getDealFilterByContractDuration(updatedArr);
  };

  const removeContractType = (contractObj) => {
    let selectedContractType = props?.selectedContractType
      ? [...props?.selectedContractType]
      : [];
    contractObj.isChecked = false;
    const updatedArr = selectedContractType.filter(
      (ct) => ct.value != contractObj.value
    );
    getDealFilterByContractType(updatedArr);
  };
  const onSeeDetailsClick = (item) => {
    let contracts = item.contract_sku;
    if (!Array.isArray(contracts)) {
      contracts = [`${contracts}`];
    } else {
      const total = contracts.length;
      const contractPosition = contracts.indexOf(item.sku);
      if (contractPosition !== -1 && contractPosition !== total - 1) {
        const filteredContracts = contracts.filter((contract) => contract !== item.sku);
        filteredContracts.push(item.sku);
        contracts = filteredContracts;
      }
    }
    showSpinner();
    router
      .push({
        pathname: `${urlPrefix}/deal-details-page/${item.url_key}`,
        query: props?.buyOption
        ? { 
            buyOption: props?.upgradeCheckDone ? "upgrade" : props?.buyOption, 
          }
        : props?.upgradeCheckDone
        ? { buyOption:  "upgrade" } 
        : null,
      })
      .then(() => {
        window.scrollTo(0, 0);
        hideSpinner();
      });
    if (!analyticsSent) {
      const [ categories ] = item?.categories ? item?.categories : [];
      let analyticsData;
      if(props.pageName === "upgrade"){
        analyticsData = {
          ...AnalyticsGetUtagData(),
          link_type: "o",
          link_name: "shopping: upgrade: recommended deals: view deal details",
          sales_product_category: [categories && categories[0] && categories[0].name],
          sales_product_id: [item?.name],
          sales_product_price: [item?.monthly_recurring],
          sales_product_quantity: 1,
          sales_order_discount: [item?.save_monthly_recurring],
          sales_promo_name: [item?.promotion_tag_label],
        };
      } else{
        analyticsData = {
          ...AnalyticsGetUtagData(),
          link_type: "use",
          link_name: (props?.isDealGridPage) ? "shopping: deal grid: view deal details" : "shopping: deal selection: deal details",
          sales_product_category: [categories && categories[0] && categories[0].name],
          sales_product_id: [item?.name],
          sales_product_price: [item?.monthly_recurring],
          sales_product_quantity: 1,
          sales_order_discount: [item?.save_monthly_recurring],
          sales_promo_name: [item?.promotion_tag_label],
        };
      }
      if (item?.deal_end_date) {
        analyticsData.deal_expiry = getDealExpiryTime(item?.deal_end_date);
      }
      AnalyticsLink(analyticsData);
      setAnalyticsSent(true);
    }
  };

const breadcrumbs = breadcrumbGenerator().deals.reverse();
const section_lvls = {};
    let index = 0;
    for (let item of breadcrumbs) {
    index = index + 1;
    if (index > 4) break;
    section_lvls[`page_site_section_lvl_${index}`] = item.label;
    }

  const resetFilterHandler = () => {
    if(props?.isDealSelection) {
      props?.resetDealSelectionFilter();
      AnalyticsLink({
        ...AnalyticsGetUtagData(),
        page_tool_event: "use",
        page_tool_name: "shopping: deal selection: reset all filters",
      });
    } else {
      props?.clearCategories()
      resetFilter();
      AnalyticsLink({
        page_name: "shopping: deals grid: browse all deals",
        page_channel: "shopping",
        page_tool_event: "use",
        page_tool_name: "shopping: deals grid: browse all deals: reset all filters",
        page_master_tab: "personal",
        ...section_lvls,
      });
  }
  };

  const handleRedirect = () => {

    showSpinner();

    const url = props?.bannerData[0]?.banner_url;

    if (!url) {
      return;
    }

    const isMiniApp = getCookieValue("miniApp") === "true";

    if (isMiniApp) {

      openBreakoutUrl(url);
      return;
    }

    window.location = `${url}`;
  };

  return props.hide && props?.featureSelected === "sort" ? (
    <div className={styles["sort-gutter"]}>
      <FilterNav
        headingName="Sort by"
        backbtn={props?.show}
        resetClickHandler={() => handleSelectedMobile()}
      />
      {dealSortValues.map((sortLabel, index) => (
        <SortContainer
          key={index}
          close ={props?.show}
          boxHeading={sortLabel.label}
          selected={
            isMobile && props?.selectedSortVal !== ""
              ? props?.selectedSortVal === sortLabel.label
              : selected === sortLabel.label
          }
          selectHandler={(flag) => handleSelectedMobile(flag, sortLabel.label)}
        />
      ))}
    </div>
  ) : (
    !props.hide && (
      <CustomContainer>
        <Row className={`${!props?.bannerData?.length && "mb-s"} ${props?.isDealSelection?styles["sort-deal-selection"]:""} ${props.pageName=="upgrade" ?styles["upgrade-row"]:""}`}>
          <CustomContainer className={`${styles.pillsDiv}`}>
            {props?.selectedBrands?.map((item) => (
              <WhitePill
                className={styles.pillSpacing}
                style={{ marginRight: "8px" }}
                key={item.sku}
                name={item.label}
                removeBtnHandler={() => removeBrandsHandler(item)}
              />
            ))}
            {props?.selectedPromotions?.map((item) => (
              <WhitePill
                className={styles.pillSpacing}
                style={{ marginRight: "8px" }}
                key={item.sku}
                name={item.label}
                removeBtnHandler={() => removePromotionsHandler(item)}
              />
            ))}
            {props?.selectedPlantype?.map((item) => (
              <WhitePill
                className={styles.pillSpacing}
                style={{ marginRight: "8px" }}
                key={item.sku}
                name={item.label}
                removeBtnHandler={() => removePlanTypeHandler(item)}
              />
            ))}
            {props?.selectedPlanname?.map((item) => (
              <WhitePill
                className={styles.pillSpacing}
                style={{ marginRight: "8px" }}
                key={item.sku}
                name={item.label}
                removeBtnHandler={() => removePlanNameHandler(item)}
              />
            ))}
            {props?.selectedAcccessories?.map((item) => (
              <WhitePill
                className={styles.pillSpacing}
                style={{ marginRight: "8px" }}
                key={item.sku}
                name={item.label}
                removeBtnHandler={() => removeAccessoriesHandler(item)}
              />
            ))}
            {props?.selectedContractDuration?.map((item) => (
              <WhitePill
                className={styles.pillSpacing}
                style={{ marginRight: "8px" }}
                key={item.sku}
                name={item.label}
                removeBtnHandler={() => removeContractDuration(item)}
              />
            ))}
            {props?.selectedContractType?.map((item) => (
              <WhitePill
                className={styles.pillSpacing}
                style={{ marginRight: "8px" }}
                key={item.sku}
                name={item.label}
                removeBtnHandler={() => removeContractType(item)}
              />
            ))}
          </CustomContainer>
          {(isUpgradePage && isMobile) && (
          <CustomContainer className={styles["info-banner-container"]}>
            <CustomContainer className={styles["info-banner"]}>
              <UpgradeInfoBar
                  type="info"
                  message={labels.lbl_upgrade_info_banner}
                  btnHandler={()=>props.setActiveTab("Past usage & spend")}
                  btnLabel={"See my past usage"}
              />
            </CustomContainer>
            <CustomContainer className={styles["filters-modal-button"]} onClick={() => props.showFiltersModal(true)}>
              <img
                className={styles["button-image"]}
                height={24}
                src={`${imagePrefix}/assets/images/filter.svg`}
                alt="filter"
              />
              <div className={styles["button-label"]}>
                {"Filter deals"}
              </div>
            </CustomContainer>
          </CustomContainer>
          )}
          <LabelText
            className={`${styles["page-info"]} ${styles["page-info-text"]}  ${ props.isDealSelection ? styles["page-info-text-btm"]:''} d-inline-flex align-items-center ${props.pageName=="upgrade" ?styles["upgrade-page-info"]:""}`}
          >
            {FilterText}
          </LabelText>
          {!isMobile && !isTablet && (
            <CustomContainer
              className={`${props.pageName !="upgrade" ? styles["price-switch"]:"upgrade-dropdown"} ${
                !isMobile ? "product-list-container deal-sort-dropdown" : ""
              } ${props.pageName =="upgrade" ? styles["disabled"]:""}`}
            >
              <LabelText className={styles["page-info-text"]}>Sort by:</LabelText>
              <DropDownComponent
                data={dealSortValues}
                handleSelect={handleSelected}
                selectedValue={
                  selected === "" ? lblRecommendedForYou : selected
                }
                customClass={props.page=='deal-list'?styles["dropdown-item"]:styles["selection-drop-down"]}
                menuClassName="sort-menu"
                id="deal-sort-menu"
              />
            </CustomContainer>
          )}
          {(isMobile || isTablet) && (
            <CustomContainer
                  className={`${styles["deal-sort-native-container-class"]} ${props.pageName =="upgrade" ? styles["disabled"]:""}`}
                >
                  <NativeSort
                    sortOptions={dealSortValues}
                    handleSelect={handleSelected}
                    selectedValue={selected === "" ? lblRecommendedForYou : selected}
                    id="deal-sort-menu-native"
                  />
            </CustomContainer>
          )}
        </Row>
        {(isUpgradePage && !isMobile) && (
          <CustomContainer className={styles["info-banner"]}>
            <UpgradeInfoBar
                type="info"
                message={labels.lbl_upgrade_info_banner}
            />
          </CustomContainer>
        )}
        {props?.items && props?.items?.length ? (
          <Row className={`${!props.isDealSelection ? "custom-grid-gutter mx-0" :"mx-0"} ${props.isDSE ? styles["upgrade_cards"]: ""}`}>
            {
              props?.bannerData && props?.bannerData?.length>0  && (
                <Col
                  md={12}
                  className={`${styles["banner"]}`}
                >
                  <GridBanner bannerData={props?.bannerData} redirectTo={handleRedirect} />
                </Col>
              )}
            {props.items.map((item) => (
              <Col key={item.sku} sm={6} md={props.pageName =="upgrade" ?6:4} lg={4} xl={props.spanXl} className={`${props.isDealSelection ? styles["deal-cards-custom-spacing"]: ""} ${props.isDSE ? styles["upgrade_cards"]:""}`}>
                <Link legacyBehavior href={{ pathname: `${urlPrefix}/deal-details-page/${item.url_key}`}}>
                  <a className={styles["dealcard-link"]}>
                    <DealCard
                      width={isMobile ? "14.12rem" : "auto"}
                      height="32.938rem"
                      img_width="10rem"
                      maxHeight="33.5rem"
                      img_height="10rem"
                      height_mobile="29.313rem"
                      img_width_mobile="7.5rem"
                      img_height_mobile="7.5rem"
                      isOutOfStock={checkIsOutOfStock(item)}
                      productName={item.name}
                      imgUrl={
                        getProductImageUrl(item, 'image',"No_image")

                      }
                      imgUrl_mobile={
                        getProductImageUrl(item, 'small_image',"No_image_1")
                      }
                      saveLabel={item?.save_monthly_recurring}
                      promotionLabel={item?.promotion_tag != null && item?.promotion_tag_label ? item?.promotion_tag_label : ''}
                      promotionLabelColor={
                        item.promotion_tag_label == types.TYPE_PREORDER
                          ? ""
                          : item.promotion_tag_swatch}
                      promotionVariant={getPromotionVariant(item)}
                      planName={
                        item.package_description ? item.package_description : ""
                      }
                      highlights={getHighlights(item)}
                      originalPrice={
                        item.monthly_recurring ? item.monthly_recurring : ""
                      }
                      offerPrice={
                        item.monthly_recurring ? item.monthly_recurring : ""
                      }
                      prevPrice={
                        item.old_monthly_recurring ? item.old_monthly_recurring : ""
                      }
                      numberOfMonths={item.payment_terms_label}
                      buttonText={
                        item.promotion_tag_label == types.TYPE_PREORDER
                          ? labels.lbl_preorder_now
                          : (!props?.isDealSelection
                              ? labels.lbl_see_details
                              : labels.lbl_deal_selection_page_card_btn)
                      }
                      buttonHandler={() => onSeeDetailsClick(item)}
                      deal_end_date={item.deal_end_date}
                      deal_go_live_date={item.deal_go_live_date}
                      deal_label={item.deal_label}
                      is_deal_locked={item.is_deal_locked}
                      className="deal-list-items"
                      campaignFlag={false}
                    />
                  </a>
                </Link>
              </Col>
            ))}
          </Row>
        ) : (
          <Row className={`${styles["containerheight"]} custom-grid-empty-gutter`}>
            <Col>
              <EmptyProductsContainer
                resetFilter={resetFilterHandler}
                message={props.showQualifyDeals ? labels.upgrade.lbl_deals_no_products : null}
                ctaHidden={props.showQualifyDeals}
              />
            </Col>
          </Row>
        )}
        {totalPages > 0 && (
          <PageCounter
            pageNumber={props?.pageInfo?.current_page}
            totalPages={totalPages}
            increasePageCount={increasePageCount}
            decreasePageCount={decreasePageCount}
            handleCurrentPageChange={(cPage) => handleCurrentPageChange(cPage)}
            className={!isMobile ? "grid-pagination" : ""}
          />
        )}
      </CustomContainer>
    )
  );
};

DealListContainer.propTypes = {
  items: PropTypes.array,
  hide: PropTypes.bool,
  selectedbrands: PropTypes.array,
  displayHideFooter: PropTypes.func,
  analyticsHandleSortFilter: PropTypes.func,
  showQualifyDeals: PropTypes.bool,
  pageName: PropTypes.string
};

export default connect(null, {
  displayHideFooter,
})(DealListContainer);